export const mockData = {
  whatsappNumber: '61406643030',
  
  stats: [
    { value: '50+', label: 'Happy Customers' },
    { value: '10+', label: 'Quality Cars' },
    { value: '24/7', label: 'Support' },
    { value: '5★', label: 'Average Rating' }
  ],

  cars: [
    {
      id: 1,
      name: 'Honda HR-V',
      category: 'suv',
      features: ['Carplay', 'Cruise control'],
      seats: 5,
      transmission: 'Automatic',
      pricePerDay: 95,
      image: 'https://customer-assets.emergentagent.com/job_driveez-rentals/artifacts/eok4v348_87C88A91-2442-4D91-81B1-6A1D062A2F6F.PNG'
    },
    {
      id: 2,
      name: 'Kia Cerato',
      category: 'economy',
      features: ['Spacious', 'Bluetooth'],
      seats: 5,
      transmission: 'Automatic',
      pricePerDay: 75,
      image: 'https://customer-assets.emergentagent.com/job_driveez-rentals/artifacts/tl3ue31b_A6E8C26A-5633-4A7B-BEA8-5FF8923CE1D9.PNG'
    },
    {
      id: 3,
      name: 'Hyundai i30',
      category: 'economy',
      features: ['Cruise control', 'Carplay'],
      seats: 5,
      transmission: 'Automatic',
      pricePerDay: 70,
      image: 'https://customer-assets.emergentagent.com/job_driveez-rentals/artifacts/v3dvq5jb_243E09A8-D83A-450B-81C1-3141BCA52358.PNG'
    },
    {
      id: 4,
      name: 'Hyundai i30',
      category: 'economy',
      features: ['Comfortable', 'Bluetooth'],
      seats: 5,
      transmission: 'Automatic',
      pricePerDay: 70,
      image: 'https://customer-assets.emergentagent.com/job_driveez-rentals/artifacts/f3v8t5cl_DDD99BAD-E9AA-48A4-931B-32ECC6D6FD3D.PNG'
    },
    {
      id: 5,
      name: 'Kia Rio Sports',
      category: 'economy',
      features: ['Fuel efficient', 'Bluetooth'],
      seats: 5,
      transmission: 'Automatic',
      pricePerDay: 65,
      image: 'https://customer-assets.emergentagent.com/job_driveez-rentals/artifacts/ukfhvs4m_CD783E53-137B-4A0F-8153-50C1F00EC144.PNG'
    },
    {
      id: 6,
      name: 'Mazda 2',
      category: 'economy',
      features: ['Fuel efficient', 'Easy to park'],
      seats: 5,
      transmission: 'Automatic',
      pricePerDay: 60,
      image: 'https://customer-assets.emergentagent.com/job_driveez-rentals/artifacts/manqei4x_E3350F22-B734-4DAD-A447-FF4B94DEDF5A.PNG'
    },
    {
      id: 7,
      name: 'Mazda 2',
      category: 'economy',
      features: ['Fuel efficient', 'Easy to park'],
      seats: 5,
      transmission: 'Automatic',
      pricePerDay: 60,
      image: 'https://customer-assets.emergentagent.com/job_d27798c0-b7cf-4b7d-b47a-6504fc18b842/artifacts/8dd51cqx_6E3475E4-515F-45A1-B136-EE87DDFA242C.PNG'
    },
    {
      id: 8,
      name: 'Mazda 3',
      category: 'economy',
      features: ['Fuel efficient', 'Easy to park'],
      seats: 5,
      transmission: 'Automatic',
      pricePerDay: 60,
      image: 'https://customer-assets.emergentagent.com/job_d27798c0-b7cf-4b7d-b47a-6504fc18b842/artifacts/quhhr80q_D1ED5D83-FE01-495D-95D0-C13188C52398.PNG'
    },
    {
      id: 9,
      name: 'Honda Jazz',
      category: 'economy',
      features: ['Flexible boot', 'Practical'],
      seats: 5,
      transmission: 'Automatic',
      pricePerDay: 60,
      image: 'https://customer-assets.emergentagent.com/job_driveez-rentals/artifacts/p0otrv8u_E0784918-C9C5-4EEB-992F-28E4516EECC3.PNG'
    },
    {
      id: 10,
      name: 'Mazda 2',
      category: 'economy',
      features: ['Compact', 'Fuel efficient'],
      seats: 5,
      transmission: 'Automatic',
      pricePerDay: 55,
      image: 'https://customer-assets.emergentagent.com/job_driveez-rentals/artifacts/7ss9pcw6_637E425A-4760-4276-B612-4455300941C3.PNG'
    },
    {
      id: 11,
      name: 'Honda Jazz',
      category: 'economy',
      features: ['Flexible boot', 'Practical'],
      seats: 5,
      transmission: 'Automatic',
      pricePerDay: 60,
      image: 'https://customer-assets.emergentagent.com/job_d27798c0-b7cf-4b7d-b47a-6504fc18b842/artifacts/z403ctjj_43DED3E9-E0AD-46CA-A7E7-9926DF11F77F.PNG'
    }
  ],

  features: [
    {
      icon: 'DollarSign',
      title: 'Fair Prices',
      description: 'No hidden fees. Clear pricing. Pay only what you see.'
    },
    {
      icon: 'Car',
      title: 'Reliable Cars',
      description: 'Well-maintained vehicles you can trust. Checked before every rental.'
    },
    {
      icon: 'Clock',
      title: 'Easy Booking',
      description: 'Book via WhatsApp in minutes. No complicated forms.'
    },
    {
      icon: 'Shield',
      title: 'Fully Insured',
      description: 'All cars include insurance. Drive with peace of mind.'
    }
  ]
};
